import { Link } from 'react-router-dom';
import { getTopRatedComics } from '@/mocks/comics';

export default function FeaturedComics() {
  const featuredComics = getTopRatedComics(6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              推荐韩漫
            </h2>
            <p className="mt-2 text-sm text-foreground-500">精选高分韩国漫画，品质保证</p>
          </div>
          <Link
            to="/category/romance"
            className="whitespace-nowrap hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop="">
          {featuredComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group block"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 免费韩漫在线观看`}
                  title={`${comic.title} - 韩国漫画网推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded-md">
                    {comic.rating}
                  </span>
                </div>
                {comic.status === 'completed' && (
                  <div className="absolute top-2 right-2 px-2 py-0.5 bg-accent-500 text-white text-xs font-medium rounded-md">
                    完结
                  </div>
                )}
              </div>
              <h3 className="mt-3 text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500">{comic.author}</p>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/romance"
            className="whitespace-nowrap inline-flex items-center gap-1.5 text-sm font-medium text-primary-600"
          >
            查看全部推荐
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}